import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type SORT_KEYS} from './constants';

const domain = 'MANAGE_CHILDREN_V2'; // TODO remove v2 suffix

export const {
    action: fetchChildren,
    success: fetchChildrenSuccess,
    failed: fetchChildrenFailed,
} = createAction(
    `${domain}/FETCH_CHILDREN_AND_PLANS`,
    (institutionId: string, embedRelations: boolean, includeFuture: boolean, includePast: boolean) => ({
        institutionId,
        embedRelations,
        includeFuture,
        includePast,
    }),
    (children: List<any>) => ({children}),
);

export const {action: toggleSorting} = createAction(`${domain}/TOGGLE_NAME_SORTING`, (sortKey: SORT_KEYS) => ({
    sortKey,
}));

export const {action: setShowModal} = createAction(`${domain}/SET_SHOW_ADD_CHILD_MODAL`, (show: boolean) => ({
    show,
}));

export const {action: createNewChild, success: createNewChildSuccess} = createAction(
    `${domain}/CREATE_NEW_CHILD`,
    () => ({}),
    (childId: string) => ({childId}),
);

export const {action: createNewChildFailed} = createAction(`${domain}/CREATE_NEW_CHILD_FAILED`, () => ({}));

export const {action: setRoleInvitationIds} = createAction(
    `${domain}/SET_ROLE_INVITATION_IDS`,
    (roleInvitationIds: string[]) => ({roleInvitationIds}),
);
